import { Button, Chip, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Form, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import _ from 'lodash';
import axios from 'axios';
import classes from '../../../../pages/admin/Communication.module.scss'

const VendorSearch = ({ isSearchPopupOpen, setIsSearchPopupOpen, selectedVendors, setSelectedVendors }) => {

  const [inputValue, setInputValue] = useState(null);
  const [isVendorSearchLoading, setIsVendorSearchLoading] = useState(false);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value?.length > 0) {
        searchVendors();
      } else setVendors([]);
    }, 1000);

    debouncedHandler(inputValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [inputValue]);

  const searchVendors = async () => {
    try {
      setIsVendorSearchLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/search-vendor/${inputValue}`);
      console.log(res.data.vendors);
      setVendors(res.data.vendors)
      setIsVendorSearchLoading(false);
    } catch (error) {
      setIsVendorSearchLoading(false);
      console.error(error)
    }
  }

  const addVendorToSelectedList = (vendor) => {
    if (!checkIfVendorIsSelected(vendor)) {
      const tempSelectedVendors = _.cloneDeep(selectedVendors)
      tempSelectedVendors.push(vendor);
      setSelectedVendors(tempSelectedVendors);
      setInputValue('')
      setVendors([])
    }
  }

  const checkIfVendorIsSelected = (vendor) => {
    return selectedVendors.map(v => v.vendor_id).indexOf(vendor.vendor_id) === -1 ? false : true;
  } 

  const handleDeleteChip = (vendor) => {
    const tempSelectedVendors = _.cloneDeep(selectedVendors);
    setSelectedVendors(tempSelectedVendors.filter(v => v.vendor_id !== vendor.vendor_id))
  }

  return (
    <>
      <Modal className="composeModal" isOpen={isSearchPopupOpen} toggle={() => setIsSearchPopupOpen(false)}>
        <ModalHeader toggle={() => setIsSearchPopupOpen(false)}>Vendor Search</ModalHeader>
        <ModalBody>
          <Form className={classes.composeForm}>
            <div>
              <TextField
                id="standard-search"
                label="Search Vendor"
                type="search"
                variant="outlined"
                value={inputValue}
                className={`${vendors?.length == 0 && selectedVendors?.length > 0? 'customTextFieldWithSelectedResultsWithNoSearchValue' : selectedVendors?.length > 0 ? 'customTextFieldWithSelectedResults' : vendors?.length > 0 ? 'customTextFieldWithResults' : 'customTextField'}`}
                disabled={isVendorSearchLoading}
                onChange={(e) => setInputValue(e.target.value)}
                InputProps={selectedVendors.length > 0 ? {
                  startAdornment: <div style={{ display: 'flex', alignItems: 'center', columnGap: 10, overflow: 'auto' }}>{selectedVendors.map((vendor, index) => (
                    <Chip
                      key={index}
                      label={vendor.name}
                      onDelete={() => handleDeleteChip(vendor)}
                    />
                  ))}</div>
                } : null}
              />
              {vendors.length > 0 && <div className={classes.searchVendorList}>
                {vendors.map((vendor, index) => {
                  return (
                    <div className={classes.searchVendor} style={{cursor: `${checkIfVendorIsSelected(vendor) ? 'not-allowed' : 'pointer'}`, filter: `${checkIfVendorIsSelected(vendor) ? 'contrast(0.5)' : 'contrast(1)'}`}} onClick={() => addVendorToSelectedList(vendor)}>
                      <div className={classes.vendorName}>{vendor.name}</div>
                      <div className={classes.vendorPhone}>{vendor.phone_num}</div>
                    </div>
                  )
                })}
              </div>}
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isVendorSearchLoading} color="primary" onClick={() => setIsSearchPopupOpen(false)}>
            Add Vendors
          </Button>
          <Button disabled={isVendorSearchLoading} color="secondary" onClick={() => setIsSearchPopupOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default VendorSearch;